import { useContext, useState, useEffect } from 'react'
import { ClientContext } from '../../../contexts/clientProvider'
import { AnexosContext } from '../../../contexts/anexosProvider'
import { UserContext } from '../../../contexts/userProvider'
import LinhasEdit from '../../Anexos/Linhas/linhasEdit'
import DataTable from '../../Table'
import LoadingSpinner from '../../Loader/load'
import BaseSelect from '../../General/FormsComp/Select/BaseSelect'


const Consulta = () => {
    const { clientes, setAlert } = useContext(ClientContext);
    const { anexosByClient, linhasByAnexo, deleteLinhaById } = useContext(AnexosContext);
    const { isGerente } = useContext(UserContext);
    const [clients, setClients] = useState(null);
    const [anexos, setAnexos] = useState(null);
    const [linhas, setLinhas] = useState(null);
    const [linhaSelecionada, setLinhaSelecionada] = useState(null);
    const [loading, setLoading] = useState(false);
    const [selectedClient, setSelectedClient] = useState('');
    const [selectedAnexo, setSelectedAnexo] = useState('');

    useEffect(() => {
        let newClients = clientes ? clientes : [];
        setClients(newClients);
    }, [clientes]);

    async function handleSelectClient(e) {
        const idCliente = e.target.value
        setSelectedClient(idCliente)
        setSelectedAnexo('')
        setAnexos(null)
        setLinhas(null)
        if (idCliente) {
            const anexos = await anexosByClient(idCliente)
            setAnexos(anexos)
        }
    }

    async function handleSelectAnexo(e) {
        const idAnexo = e.target.value
        setSelectedAnexo(idAnexo)
        setLoading(true)
        if (idAnexo) {
            const linhas = await linhasByAnexo(idAnexo)
            setLinhas(linhas)
        } else {
            setLinhas(null)
        }
        setLoading(false)
    }
    const visualizar = (linha) => {
        const linhaSelecionada = linhas.find(l => l.id === linha)
        setLinhaSelecionada(linhaSelecionada)
    }

    const deletar = (linha) => {
        if (!linha) return console.error('ID não informado');
        setAlert({
            type: 'confirm',
            placeholder: 'Deseja realmente deletar a linha?',
            visible: true,
            confirm: true,
            title: 'Atenção!',
            callback: () => deleteLinhaById(linha),
            params: linha
        })
    }

    const closeEditModal = () => {
        setLinhaSelecionada(null)
    }

    const headers = [
        { label: "Linha", key: "linha", sortable: true },
        { label: "Operadora", key: "operadora", sortable: false },
        { label: "Status", key: "status", sortable: false },
        { label: "Status Atual", key: "status_atual", sortable: false },
        {
            label: "Ações", key: "actions", sortable: false,
            actions: {
                visualizar,
                ...(isGerente ? { deletar } : {}),
            }
        },
    ]

    return (
        <div className='space-y-6' style={{ overflow: 'visible' }}>
            <div className='grid grid-cols-1 md:grid-cols-2 gap-4' style={{ overflow: 'visible' }}>
                <BaseSelect
                    label="Cliente"
                    name="cliente"
                    value={selectedClient}
                    onChange={handleSelectClient}
                    options={clients ? clients.slice().sort((a, b) => a.nome.localeCompare(b.nome)) : []}
                    placeholder="Selecione o cliente"
                    valueKey="id"
                    labelKey="nome"
                />
                
                <BaseSelect
                    label="Anexo"
                    name="anexo"
                    value={selectedAnexo}
                    onChange={handleSelectAnexo}
                    options={anexos ? anexos.slice().sort((a, b) => a.nome.localeCompare(b.nome)) : []}
                    placeholder="Selecione o anexo"
                    valueKey="id"
                    labelKey="nome"
                    disabled={!anexos}
                />
            </div>
            
            {loading && (
                <div className='flex justify-center py-8'>
                    <LoadingSpinner />
                </div>
            )}
            
            {!loading && !linhas && !anexos && (
                <div className='bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700'>
                    <div className='text-center py-12'>
                        <div className='text-gray-400 dark:text-gray-500 text-6xl mb-4'>
                            📋
                        </div>
                        <h3 className='text-lg font-medium text-gray-900 dark:text-white mb-2'>
                            Selecione um cliente
                        </h3>
                        <p className='text-gray-500 dark:text-gray-400'>
                            Escolha um cliente na lista acima para visualizar seus anexos
                        </p>
                    </div>
                </div>
            )}
            
            {anexos && !linhas && !loading && (
                <div className='bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700'>
                    <div className='text-center py-12'>
                        <div className='text-gray-400 dark:text-gray-500 text-6xl mb-4'>
                            📄
                        </div>
                        <h3 className='text-lg font-medium text-gray-900 dark:text-white mb-2'>
                            Selecione um anexo
                        </h3>
                        <p className='text-gray-500 dark:text-gray-400'>
                            Escolha um anexo para visualizar suas linhas
                        </p>
                    </div>
                </div>
            )}
            
            {linhas && linhas.length > 0 && (
                <div className='bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700'>
                    <div className='p-4 border-b border-gray-200 dark:border-gray-700'>
                        <h3 className='text-lg font-semibold text-gray-900 dark:text-white'>
                            Linhas do Anexo
                        </h3>
                    </div>
                    <DataTable headers={headers} data={linhas} itemsPerPage={10} />
                </div>
            )}
            
            {linhas && linhas.length === 0 && !loading && (
                <div className='bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700'>
                    <div className='text-center py-12'>
                        <div className='text-gray-400 dark:text-gray-500 text-6xl mb-4'>
                            📞
                        </div>
                        <h3 className='text-lg font-medium text-gray-900 dark:text-white mb-2'>
                            Nenhuma linha encontrada
                        </h3>
                        <p className='text-gray-500 dark:text-gray-400'>
                            Este anexo não possui linhas cadastradas
                        </p>
                    </div>
                </div>
            )}
            
            {linhaSelecionada && <LinhasEdit closeEditModal={closeEditModal} linha={linhaSelecionada} />}
        </div>
    )
}

export default Consulta
